<template>
    <cp-select
        :config="config"
        item-value="id"
        clearable
        v-on="$listeners"
        v-bind="attrs"
        :customSelection="true"
        :returnObject="true"
        :customItem="true"
    >
        <template v-slot:selection="{ item }">
            {{ `Schema: ${contractId(item.tenant.schema)} - ${item.trade_name} - Doc: ${item.document}` }}
        </template>

        <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-content>
                    <v-list-item-title>
                        <strong>Razão Social:</strong> {{ item.legal_name }}<br>
                        <strong>Nome Fantasia:</strong> {{ item.trade_name }}<br>
                        <strong>Schema:</strong> {{ contractId(item.tenant.schema) }}<br>
                        <strong>Login code:</strong> {{ item.tenant.login_code }}<br>
                        <strong>Documento:</strong> {{ item.document }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </cp-select>
</template>

<script>

export default {
    props: {
        routeCompanies: {
            type: Object,
            required: false,
            default: () => { return {route: 'v2.core.companies'} },
        },
        config: {
            type: Object,
            required: false,
            default: () => { return {} },
        }
    },

    created() {
        this.init();
    },

    computed: {
        attrs() {
            const { label, name, ...attrs } = this.$attrs;

            return { ...{
                label: label || 'Selecione uma Empresa',
                name: name || "select-company"
            }, ...attrs };
        },
    },

    methods: {
        contractId(schema) {
            return schema ? schema.replace('u', '') : ''
        },

        init() {
            this.config.route = this.routeCompanies.route;

            // Se existem filtros, adiciona à configuração
            if (this.routeCompanies.filters) {
                this.config.filters = this.routeCompanies.filters;
            }
        },
    }
}
</script>